// Fix: prevent duplicate add-to-cart on browser back navigation (bfcache)
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    document.querySelectorAll('add-to-cart-component').forEach((el) => {
      const btn = el.refs?.addToCartButton;
      if (btn) {
        btn.removeAttribute('data-added');
        btn.disabled = false;
      }
    });

    document.querySelectorAll('product-form-component form').forEach((form) => {
      form.addEventListener('submit', (e) => e.preventDefault(), { once: true });
    });
  }
});
